// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ddbccfc0","455":"e057defe","977":"43860f3e"}[chunkId] + ".chunk.js";
};